import React from 'react';
import Layout from '../Layout';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import TestimonialsSection from './TestimonialsSection';
import AboutSection from './AboutSection';
import StatsSection from './StatsSection';
import ContactSection from './ContactSection';
import CTASection from './CTASection';

const LandingPage = () => {
  return (
    <Layout>
      <HeroSection />
      <ServicesSection />
      <TestimonialsSection />
      <AboutSection />
      <StatsSection />
      <ContactSection />
      <CTASection />
    </Layout>
  );
}

export default LandingPage;